<div class="bc-form-field" [attr.data-automation-required]="data.required">
  <div class="bc-form-row" [ngClass]="{ 'bc-form-error': data.error }">
    <div class="bc-label-row clearfix" [ngClass]="{ 'bc-form-required': data.required }">
      <label *ngIf="!isBuiltInField(data.category)" class="bc-label bc-truncate">{{ data.label }}</label>
      <label *ngIf="isBuiltInField(data.category)" class="bc-label bc-truncate">{{ data.label | translate }}</label>
      <span class="bc-label bc-label-required" *ngIf="!data.error">{{ 'bcFormField.requiredLabel' | translate }}</span>
      <span class="bc-label bc-label-required js-field-error" *ngIf="data.error">{{ 'bcFormField.fieldRequired' | translate }}</span>
    </div>

    <!-- Single line field -->
    <input *ngIf="data.type === fields.SINGLETEXT" class="bc-input" name="{{ data.name }}" type="text" [(ngModel)]="data.value" required="data.required" />

    <!-- Select hierarchy field -->
    <app-hierarchy-dropdown *ngIf="data.type === fields.DROPDOWN"
                        [sortFieldsByText]="true"
                        (onItemSelected)="dropdownValueChanged($event)"
                        [value]="data.value"
                        [items]="data.itemsFlatList"
                        [valuePropertyName]="'value'"
                        [parentIdPropertyName]="'parentFolderId'"
                        [textPropertyName]="'label'"
                        [isParentItemPropertyName]="'isFolder'"
                        placeholder="{{ 'bcFormField.dropdownDefault' | translate }}"
                        required="data.required">
    </app-hierarchy-dropdown>

    <!-- Multi line field -->
    <textarea *ngIf="data.type === fields.TEXTAREA" class="bc-textarea" name="{{ data.name }}" [(ngModel)]="data.value" required="data.required" rows="4"></textarea>

    <!-- Radiobox field -->
    <div *ngIf="data.type === fields.RADIOBOX">
      <label class="bc-label-multi" *ngFor="let o of data.options.fields">
        <input class="bc-input-multi" name="{{ data.name }}" type="radio" [checked]="o.value === data.value" [value]="o.value" required="data.required" (change)="onRadioBoxValueChange(o.value)" />
        <span class="bc-label">{{ o.label }}</span>
      </label>
    </div>
  </div>
</div>
